module.exports = __webpack_public_path__ + "img/img.560c2064.png";